import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';

@Component({
  selector: 'dialog-paid-loan',
  templateUrl: './dialog-paid-loan.component.html',
  styleUrls: ['./dialog-paid-loan.component.scss']
})
export class DialogPaidLoanComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogPaidLoanComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  insertPaidLoan() {
    this.privateService.insertPaidLoan(this.data.hr_loanlines_id).subscribe((res) => {
      console.log(res);
      this.dialogRef.close();
      window.location.reload();
    })
  }
}
